import { render, staticRenderFns } from "./zhongyitizhi.vue?vue&type=template&id=0b3ceec9&"
import script from "./zhongyitizhi.vue?vue&type=script&lang=ts&"
export * from "./zhongyitizhi.vue?vue&type=script&lang=ts&"
import style0 from "./zhongyitizhi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports